/* custom-inner-zoom.js — lupa en PC, paneo con el dedo en móvil */
document.addEventListener('DOMContentLoaded', () => {
  const ZOOM = 2;
  const zoomContainers = document.querySelectorAll('[data-inner-zoom]');

  zoomContainers.forEach((container) => {
    const img = container.querySelector('img');
    if (!img) return;

    let lastTouch = null;
    let didPan = false;
    let touchMode = false;
    let pan = { x: 0, y: 0 };

    container.addEventListener('click', (e) => {
      if (didPan) {
        didPan = false;
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      container.classList.toggle('is-zoomed');

      if (container.classList.contains('is-zoomed')) {
        if (touchMode) {
          startTouchZoom(e);
        } else {
          clearTouchPan();
          setOriginFromPointer(e, container, img);
        }
      } else {
        resetZoom();
      }
    });

    container.addEventListener('mousemove', (e) => {
      if (!container.classList.contains('is-zoomed')) return;
      if (touchMode || lastTouch) return;
      setOriginFromPointer(e, container, img);
    });

    container.addEventListener('mouseleave', () => {
      if (touchMode || lastTouch) return;
      container.classList.remove('is-zoomed');
      resetZoom();
    });

    container.addEventListener(
      'touchstart',
      (e) => {
        if (!e.touches.length) return;
        touchMode = true;
        lastTouch = {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
        };
        if (container.classList.contains('is-zoomed')) {
          e.stopPropagation();
        }
      },
      { passive: true },
    );

    container.addEventListener(
      'touchmove',
      (e) => {
        if (!container.classList.contains('is-zoomed') || !e.touches.length) return;
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();

        const touch = e.touches[0];
        if (lastTouch) {
          const dx = touch.clientX - lastTouch.x;
          const dy = touch.clientY - lastTouch.y;
          if (Math.abs(dx) > 2 || Math.abs(dy) > 2) didPan = true;
          panBy(dx, dy);
        }
        lastTouch = { x: touch.clientX, y: touch.clientY };
      },
      { passive: false },
    );

    container.addEventListener(
      'touchend',
      (e) => {
        lastTouch = null;
        if (container.classList.contains('is-zoomed')) e.stopPropagation();
      },
      { passive: true },
    );

    container.addEventListener(
      'touchcancel',
      () => {
        lastTouch = null;
      },
      { passive: true },
    );

    function maxPan() {
      const rect = container.getBoundingClientRect();
      return {
        x: ((ZOOM - 1) / 2) * rect.width,
        y: ((ZOOM - 1) / 2) * rect.height,
      };
    }

    function applyTouchPan() {
      const max = maxPan();
      pan.x = Math.max(-max.x, Math.min(max.x, pan.x));
      pan.y = Math.max(-max.y, Math.min(max.y, pan.y));
      img.style.transformOrigin = '50% 50%';
      img.style.transform = `translate(${pan.x}px, ${pan.y}px) scale(${ZOOM})`;
    }

    function startTouchZoom(e) {
      const rect = container.getBoundingClientRect();
      const point = clientPoint(e);
      pan.x = -(point.x - (rect.left + rect.width / 2)) * (ZOOM - 1);
      pan.y = -(point.y - (rect.top + rect.height / 2)) * (ZOOM - 1);
      applyTouchPan();
    }

    function panBy(dx, dy) {
      pan.x += dx;
      pan.y += dy;
      applyTouchPan();
    }

    function clearTouchPan() {
      pan = { x: 0, y: 0 };
      img.style.transform = '';
    }

    function resetZoom() {
      pan = { x: 0, y: 0 };
      img.style.transform = '';
      img.style.transformOrigin = 'center center';
    }
  });

  function clientPoint(e) {
    if (e.touches && e.touches.length > 0) {
      return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }
    return { x: e.clientX, y: e.clientY };
  }

  function setOriginFromPointer(e, container, img) {
    const rect = container.getBoundingClientRect();
    const point = clientPoint(e);
    let xPercent = ((point.x - rect.left) / rect.width) * 100;
    let yPercent = ((point.y - rect.top) / rect.height) * 100;
    xPercent = Math.max(0, Math.min(100, xPercent));
    yPercent = Math.max(0, Math.min(100, yPercent));
    img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
  }
});
